import { request } from './http';

// 分销端剧目仅允许读取合作方已获授权的内容，禁止沿用平台级 /api/programs 写接口。
export const getProgramList = (params = {}) => {
  const data = { keyword: String(params.keyword ?? '').trim(), page: params.page || 1, per_page: params.per_page || 20 };
  if (params.source) data.source = params.source;
  if (params.language) data.language = params.language;
  if (params.online_status !== '' && params.online_status !== undefined && params.online_status !== null) {
    data.online_status = params.online_status;
  }
  // 创建广告表单传的是 app_id，分销剧目接口要求 app_ids；兼容单值和数组，统一转为数组下发。
  // 不能丢掉 app_id：带 language 而未带 app_ids 时，后端会回退到语言版本自身的上架状态筛选。
  const rawAppIds = params.app_ids ?? params.app_id;
  const appIds = Array.isArray(rawAppIds) ? rawAppIds : rawAppIds !== '' && rawAppIds != null ? [rawAppIds] : [];
  if (appIds.length) data.app_ids = appIds;
  return request('/api/distributor/drama/list', { method: 'post', data });
};

export const getDistributorDramaSources = () => request('/api/distributor/drama/sources', { method: 'post', data: {} });

const withAppIds = (data, appIds) => {
  const ids = Array.isArray(appIds) ? appIds : appIds !== '' && appIds != null ? [appIds] : [];
  return ids.length ? { ...data, app_ids: ids } : data;
};

export const getDistributorDramaDetail = (videoId, appIds = []) =>
  request('/api/distributor/drama/detail', { method: 'post', data: withAppIds({ video_id: videoId }, appIds) });

export const getDistributorDramaEpisodes = (videoLanguageId, appIds = []) =>
  request('/api/distributor/drama/episodes', { method: 'post', data: withAppIds({ video_language_id: videoLanguageId }, appIds) });

export const getDistributorSeriesEpisodes = (source, channelSeriesId, appId) =>
  request('/api/distributor/drama/series-episodes', {
    method: 'post',
    data: { source, channel_series_id: channelSeriesId, app_id: appId }
  });

// 分集预览与下载分别获取短时 HLS 清单，前端不再直接访问永久桶资源路径。
export const previewDistributorEpisode = (episodeId, appIds = []) =>
  request('/api/distributor/drama/previewByHls', { method: 'post', data: withAppIds({ episode_id: episodeId }, appIds) });

export const downloadDistributorEpisode = (episodeId, appIds = []) =>
  request('/api/distributor/drama/downloadByHls', { method: 'post', data: withAppIds({ episode_id: episodeId }, appIds) });

export const validateDistributorResources = (data) => request('/api/distributor/drama/validate', { method: 'post', data });

export const getDistributorContext = () => request('/api/distributor/context/current', { method: 'post', data: {} });

export const getDistributorMembers = (params = {}) =>
  request('/api/distributor/member/list', {
    method: 'post',
    data: {
      keyword: params.keyword || '',
      page: params.page || 1,
      per_page: params.per_page || 20,
      ...(params.organization_id ? { organization_id: params.organization_id } : {})
    }
  });

export const createDistributorMember = (data) => request('/api/distributor/member/create', { method: 'post', data });

export const attachDistributorMember = (data) => request('/api/distributor/member/attach', { method: 'post', data });

export const searchDistributorUsers = (data) => request('/api/distributor/member/user/search', { method: 'post', data });

export const updateDistributorMember = (data) => request('/api/distributor/member/update', { method: 'post', data });

export const removeDistributorMember = (data) => request('/api/distributor/member/remove', { method: 'post', data });

export const getDistributorOrgTree = (data = {}) => request('/api/distributor/organization/tree', { method: 'post', data });

export const createDistributorOrg = (data) => request('/api/distributor/organization/create', { method: 'post', data });
export const updateDistributorOrg = (data) => request('/api/distributor/organization/update', { method: 'post', data });

export const getDistributorOrgSupplies = (data) => request('/api/distributor/organization/supplies', { method: 'post', data });

export const getDistributorOrgAuthorizations = (data) => request('/api/distributor/organization/authorizations', { method: 'post', data });

export const getDistributorOrgAudits = (data) => request('/api/distributor/organization/audits', { method: 'post', data });

export const getAdTasks = (params) => request('/api/ad_publish/tasks', { params });
export const getAdTaskDetail = (id, params) => request(`/api/ad_publish/tasks/${id}`, { params });
export const createAdTask = (data) => request('/api/ad_publish/tasks', { method: 'post', data });
export const publishAdTask = (data) => request('/api/ad_publish/dealwith', { method: 'post', data });
export const deleteAdDraft = (id) => request(`/api/ad_publish/tasks/${id}`, { method: 'delete' });
export const stopAdTask = (id) => request(`/api/ad_publish/tasks/${id}/status`, { method: 'patch' });

export const getMaterialFolders = (params) => request('/api/materials/folders', { params });
export const getMaterialWorkbenchFolders = (params) => request('/api/materials/workbench/folders', { params });
export const createMaterialFolder = (data) => request('/api/materials/folders', { method: 'post', data });
export const addMaterialFolder = (data) => request('/api/materials/folders', { method: 'post', data });
export const updateMaterialFolder = (id, data) => request(`/api/materials/folders/${id}`, { method: 'post', data });
export const updateMaterialFolderName = (id, data) => request(`/api/materials/folders/${id}/name`, { method: 'post', data });
export const moveMaterialFolder = (id, data) => request(`/api/materials/folders/${id}/move`, { method: 'post', data });
export const deleteMaterialFolder = (id, params) => request(`/api/materials/folders/${id}`, { method: 'delete', params });
export const getMaterials = (params, config = {}) => request('/api/materials', { params, ...config });
export const getMaterialWorkbenchMeta = (params, config = {}) => request('/api/materials/workbench/meta', { params, ...config });
export const getMaterialUploadDateBatches = (params, config = {}) =>
  request('/api/materials/workbench/upload-date-batches', { params, ...config });
export const updateMaterial = (id, data) => request(`/api/materials/${id}`, { method: 'put', data });
export const deleteMaterial = (id, params) => request(`/api/materials/${id}`, { method: 'delete', params });
export const toggleMaterialFavorite = (id) => request(`/api/materials/${id}/favorite`, { method: 'post' });
export const batchEditMaterials = (data) => request('/api/materials/batch', { method: 'post', data });
export const batchDeleteMaterials = (data) => request('/api/materials/batch', { method: 'delete', data });
export const uploadMaterials = (data) => request('/api/materials/upload', { method: 'post', data });
export const uploadKsMaterials = (data) => request('/api/materials/upload-ks', { method: 'post', data });
export const uploadTikTokMaterials = (data) => request('/api/materials/upload-tiktok', { method: 'post', data });

export const getCopywritings = (params) => request('/api/ad_publish/copywritings', { params });
export const createCopywriting = (data) => request('/api/ad_publish/copywritings', { method: 'post', data });
export const updateCopywriting = (id, data) => request(`/api/ad_publish/copywritings/${id}`, { method: 'put', data });
export const deleteCopywriting = (id, params) => request(`/api/ad_publish/copywritings/${id}`, { method: 'delete', params });

// admanager 未提供 /ad_manage/campaigns|adsets|ads 三个旧列表路由；
// 统一复用已维护、按 search_type 分层聚合的 insights 接口，且补齐其必填日期条件。
function currentDate() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

function getAdManageList(searchType, params = {}) {
  const dateStart = params.date_start || params.date || currentDate();
  const dateEnd = params.date_end || params.date || dateStart;
  return getInsight({ ...params, date_start: dateStart, date_end: dateEnd, search_type: searchType });
}

export const getCampaigns = (params) => getAdManageList('campaign', params);
export const updateCampaign = (id, data) => request(`/api/ad_manage/campaigns/${id}`, { method: 'patch', data });
export const getAdsets = (params) => getAdManageList('adset', params);
export const updateAdset = (id, data) => request(`/api/ad_manage/adsets/${id}`, { method: 'patch', data });
export const getAds = (params) => getAdManageList('ad', params);
// 广告层级没有旧的 PATCH /ads/:id 路由，使用当前批量状态接口提交一个对象。
export const updateAd = (id, data = {}) =>
  request('/api/ad_manage/ads/status', {
    method: 'post',
    data: {
      status: data.status,
      object_type: 'ad',
      ad_objects: [{ object_id: id, account_id: data.account_id, channel: data.channel }]
    }
  });
export const getCampaignsTrend = (params) => request('/api/ad_manage/campaigns/trend', { params });

export const getApplicationInsights = (params) => request('/api/ad_manage/applications/insights', { params });
export const getApplicationDailyInsights = (appId, params) => request(`/api/ad_manage/applications/${appId}/insights/daily`, { params });
export const getApplicationDailyCycleInsights = (appId, params) =>
  request(`/api/ad_manage/applications/${appId}/insights/daily-cycle`, { params });
export const getApplication5MinInsights = (appId, params) => request(`/api/ad_manage/applications/${appId}/insights/5min`, { params });

// 数组参数（app_ids/dimensions 等）走 POST JSON body，避免 GET 逗号序列化后后端校验报「must be an array」
export const getInsight = (params) =>
  request('/api/ad_manage/insights', {
    method: 'post',
    data: params,
    responseType: params?.export === 1 ? 'text' : 'json'
  });
export const updateAdStatus = (id, data) => request(`/api/publicity-links/insights/${id}/ad-status`, { method: 'patch', data });
export const updateTikTokAdStatus = (id, data) => request(`/api/publicity-links/insights/tiktok/${id}/status`, { method: 'patch', data });
export const updateKsAdStatus = (id, data) => request(`/api/ad_manage/ks/ads/${id}/status`, { method: 'patch', data });
export const getHourlyInsight = (params) => request('/api/ad_manage/insights/hourly', { params });
export const get5MinInsight = (params) => request('/api/ad_manage/insights/5min', { params });
export const getDailyInsight = (params) => request('/api/ad_manage/insights/daily', { params });
export const getOptimizer5MinInsight = (params) => request('/api/ad_manage/insights/5min/optimizer', { params });
export const getMonthlyRoi = (params) => request('/api/ad_manage/insights/monthly-roi', { params });
export const getMaterialTopAggregationOptions = (params) => request('/api/ad_manage/material-top/aggregation-options', { params });
export const getMaterialTop = (params = {}) =>
  request('/api/ad_manage/material-top', { method: 'post', data: { ...params, query_by: 'doris' } });
export const getDesignerDailySummary = (params = {}) =>
  request('/api/ad_manage/insights/designer-daily-summary', { method: 'post', data: { ...params, query_by: 'doris' } });
export const getDramaOrganizationInsight = (params = {}) =>
  request('/api/ad_manage/drama/organization-insights', { params: { ...params, query_by: params.query_by || 'doris' } });
export const getDramaOrganizationRevenueInsight = (params = {}) =>
  request('/api/ad_manage/drama/organization-revenue-insights', { params: { ...params, query_by: params.query_by || 'doris' } });
export const getDramaInsightByDimension = (params = {}) => {
  const dimensions = params.dimensions || [];
  const primary = Array.isArray(dimensions) ? dimensions[0] : dimensions;
  return primary === 'revenue_video_id' ? getDramaOrganizationRevenueInsight(params) : getDramaOrganizationInsight(params);
};
export const getDramaFullLinkInsight = (params = {}) =>
  request('/api/ad_manage/drama/full-link-daily-insights', { params: { ...params, query_by: 'doris' } });

export const getBusinessAdAccounts = (params) => request('/api/business-ad-accounts', { params });
export const getBusinessAdAccountCapabilities = () => request('/api/business-ad-accounts/capabilities');
export const getBusinessAdAccountFilterMembers = () => request('/api/business-ad-accounts/filter-members');
export const assignBusinessAdAccounts = (data) => request('/api/business-ad-accounts/assign', { method: 'post', data });
export const changeBusinessAdAccountApp = (data) => request('/api/business-ad-accounts/change-app', { method: 'post', data });
export const revokeBusinessAdAccounts = (data) => request('/api/business-ad-accounts/revoke', { method: 'post', data });
export const syncBusinessAdAccountRules = (data) => request('/api/business-ad-accounts/sync-rules', { method: 'post', data });
export const syncBusinessAdAccountSources = (data) => request('/api/business-ad-accounts/sync-sources', { method: 'post', data });

export const getAppGroupList = (params) => request('/api/appGroups', { params });
export const getAppGroupApps = (params) => request('/api/appGroups/getApp', { params });
export const createAppGroup = (data) => request('/api/appGroups', { method: 'post', data });
export const updateAppGroup = (id, data) => request(`/api/appGroups/${id}`, { method: 'put', data });
export const deleteAppGroup = (id) => request(`/api/appGroups/${id}`, { method: 'delete' });
export const bindAppGroupApps = (id, data) => request(`/api/appGroups/${id}/apps`, { method: 'post', data });
export const sortAppGroups = (data) => request('/api/appGroups/sort', { method: 'post', data });
export const sortAppGroupApps = (id, data) => request(`/api/appGroups/${id}/apps/sort`, { method: 'post', data });
export const deleteAppGroupApp = (id, appId) => request(`/api/appGroups/${id}/apps/${appId}`, { method: 'delete' });

/** 目录业务键用于渠道选择，剧点旧版本 ID 仍用于旧广告/分集接口；外部 ID 不转 Number。 */
function toNovelOption(series) {
  const source = series.source || 'judian';
  const legacyId =
    series.legacy_video_language_id ||
    series.video_language_id ||
    (source === 'judian' && !series.channel_series_id && !series.target_language_series_id ? series.id : null);
  const channelSeriesId = series.channel_series_id || series.target_language_series_id || (source === 'judian' ? legacyId : null);
  // 保留显式旧版本 ID；没有旧映射时使用渠道业务 ID，不能回退到目录自增主键。
  const id = legacyId || channelSeriesId;
  if (!id) return null;
  const title =
    series.common_series_name || series.parent_series_name || series.series_name || series.drama?.title || series.title || '未知名称';
  const languageLabel = series.language_label || series.language || '-';
  return {
    ...series,
    source,
    channel_series_id: channelSeriesId == null ? '' : String(channelSeriesId),
    id,
    video_language_id: legacyId || null,
    video_id: series.legacy_video_id || series.video_id || null,
    title,
    drama: { ...series.drama, title },
    version_title: series.series_name || series.title,
    final_title: series.final_title || `${series.source_label || source} · ${channelSeriesId || id} -- ${title} (${languageLabel})`
  };
}

/**
 * 将分销授权目录适配为 data.list，保留来源、业务 ID 与分页信息。
 * 兼容滚动部署时旧接口的根剧目 + versions 结构；旧版本仅归属剧点，不套用请求渠道。
 */
export async function searchNovel(params = {}) {
  const response = await getProgramList(params);
  const data = response?.data || response || {};
  const rows = data.items ?? data.list ?? [];
  const list = [];
  for (const series of rows) {
    if (!Array.isArray(series.versions)) {
      const option = toNovelOption(series);
      if (option) list.push(option);
      continue;
    }
    for (const version of series.versions) {
      if (params.language && version.language !== params.language) continue;
      const option = toNovelOption({
        ...series,
        ...version,
        source: 'judian',
        source_label: '剧点',
        legacy_video_id: series.video_id,
        legacy_video_language_id: version.video_language_id,
        common_series_name: series.title,
        series_name: version.title
      });
      if (option) list.push(option);
    }
  }
  return { ...response, data: { ...data, list } };
}

/** 返回旧表单可消费的分集结构；剧目语种授权仍由 distributor API 在服务端校验。 */
export async function getNovelChapters(videoLanguageId, appIds = []) {
  const response = await getDistributorDramaEpisodes(videoLanguageId, appIds);
  const data = response?.data || response || {};
  const list = (data.episodes || []).map((episode) => ({
    id: episode.episode_id,
    title: episode.episode_num,
    episode_num: episode.episode_num,
    accessible: episode.accessible
  }));
  return { ...response, data: { ...data, list } };
}

/** 当前组织已授权的广告账户，替代未隔离的 account_manage / facebook / tiktok 账户接口。 */
export async function getCoopAdAccountCandidates({ channel, keyword = '', page = 1, per_page = 50 } = {}) {
  const response = await getBusinessAdAccounts({ channel, keyword, page, per_page });
  const data = response?.data || response || {};
  const items = data.items || data.list || (Array.isArray(data) ? data : []);
  const list = items.map((item) => ({
    ...item,
    id: item.id || item.account_id || item.external_account_id,
    account_id: item.account_id || item.external_account_id || item.id,
    advertiser_id: item.advertiser_id || item.external_account_id || item.id,
    account_name: item.account_name || item.name,
    advertiser_name: item.advertiser_name || item.name
  }));
  return { ...response, data: { ...data, list } };
}
